// extracted by mini-css-extract-plugin
export default {"content":"BasicInformation_content__u2eeT"};